import { Link } from "react-router-dom";
import { MapPin, Droplets, KeyRound, Zap, ArrowRight } from "lucide-react";
import { DEPARTMENTS } from "../lib/departments";
import Reveal from "./Reveal";

const METIERS_LIST = [
  { slug: "plombier",    label: "Plombier",    Icon: Droplets, color: "text-brand"       },
  { slug: "serrurier",   label: "Serrurier",   Icon: KeyRound, color: "text-brand-green" },
  { slug: "electricien", label: "Électricien", Icon: Zap,      color: "text-brand"       },
];

export default function DepartmentLinks() {
  const entries = Object.entries(DEPARTMENTS);
  return (
    <section data-testid="idf-departments-links" className="py-16 md:py-24 bg-slate-50 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <span className="overline">Île-de-France</span>
            <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-5xl">
              Trouvez votre <span className="gradient-text">dépanneur local</span>
            </h2>
            <p className="mt-4 text-ink-soft leading-relaxed">
              Un artisan proche de chez vous dans les 8 départements franciliens. Cliquez sur votre département
              pour découvrir nos interventions et prendre contact 24 h/24.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {entries.map(([slug, d], i) => (
            <Reveal key={slug} delay={i * 0.03}>
              <div className="card-soft p-5 hover:translate-y-0 h-full">
                <div className="flex items-center gap-2.5 mb-3">
                  <span className="h-9 w-9 rounded-lg bg-brand/10 flex items-center justify-center">
                    <MapPin className="h-4 w-4 text-brand" />
                  </span>
                  <div>
                    <p className="font-display font-extrabold text-ink text-lg leading-tight">{d.name}</p>
                    <p className="text-ink-soft text-xs">Département {d.code}</p>
                  </div>
                </div>
                <ul className="space-y-1.5">
                  {METIERS_LIST.map((m) => (
                    <li key={m.slug}>
                      <Link
                        to={`/${m.slug}-${slug}`}
                        className="group flex items-center justify-between rounded-lg px-2 py-1.5 hover:bg-slate-100 transition-colors"
                      >
                        <span className="flex items-center gap-2 text-ink-soft group-hover:text-ink text-sm">
                          <m.Icon className={`h-3.5 w-3.5 ${m.color}`} />
                          {m.label} {d.name}
                        </span>
                        <ArrowRight className="h-3.5 w-3.5 text-ink-soft/40 group-hover:text-brand group-hover:translate-x-0.5 transition-all" />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
